import Vue from 'vue'

import { OmnicaPlugin } from '~~/omnica/build/website/index.mjs'

Vue.use(OmnicaPlugin)
